<template>
  <div class="timer row">
    <div class="col-12">
      {{currentTimer}} <img src="/static/alarm.svg" class="d-none d-md-inline"/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'RoundTimer',
  props: {
    endDate: Number,
  },
  data() {
    return {
      time: '',
      currentTimer: 0,
    };
  },
  created() {
    this.updateTimer();
    this.timer = setInterval(this.updateTimer, 1000);
  },
  methods: {
    updateTimer() {
      let t = Math.ceil((this.endDate - new Date().getTime()) / 1000);
      if (t < 0) {
        t = 0;
      }
      this.currentTimer = t.toFixed(0);
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
img {
  width: 12px;
}

@media (min-width: 992px) {
  .timer{
    font-size: 1.4rem;
  }
  img {
    width: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/games/RoundTimer.vue